export const CANVAS_PRESETS = [
    { label: "Instagram Post", width: 1080, height: 1080 },
    { label: "Instagram Story", width: 1080, height: 1920 },
    { label: "Facebook Post", width: 1200, height: 630 },
    { label: "Facebook Cover", width: 851, height: 315 },
    { label: "TV Full HD (1080p)", width: 1920, height: 1080 },
    { label: "TV 4K (2160p)", width: 3840, height: 2160 },
    { label: "A4 Portrait", width: 794, height: 1123 },
    { label: "Carré 800×800", width: 800, height: 800 },
];

export const COLOR_INPUT_STYLE = {
    width: 32, height: 32, border: "none",
    padding: 0, cursor: "pointer", borderRadius: 4,
};

export const FONT_FAMILIES = [
    "Arial", "Georgia", "Times New Roman",
    "Courier New", "Verdana", "Impact", "Trebuchet MS",
];

export const EDITOR_MODES = {
    MODEL: "model",
    DESIGN: "design",
};
